var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreencheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 9.5625C18.6 11.9494 17.6518 14.2386 15.9639 15.9265C14.2761 17.6143 11.9869 18.5625 9.59998 18.5625C7.21303 18.5625 4.92384 17.6143 3.23601 15.9265C1.54819 14.2386 0.599976 11.9494 0.599976 9.5625C0.599976 7.17555 1.54819 4.88637 3.23601 3.19854C4.92384 1.51071 7.21303 0.5625 9.59998 0.5625C11.9869 0.5625 14.2761 1.51071 15.9639 3.19854C17.6518 4.88637 18.6 7.17555 18.6 9.5625ZM14.1337 6.15375C14.0534 6.07367 13.9577 6.01062 13.8524 5.96837C13.7471 5.92611 13.6344 5.90553 13.521 5.90784C13.4075 5.91015 13.2957 5.93531 13.1923 5.98181C13.0888 6.02832 12.9958 6.09521 12.9187 6.1785L9.0116 11.1566L6.65698 8.80087C6.49703 8.65183 6.28548 8.5707 6.06689 8.57455C5.8483 8.57841 5.63974 8.66696 5.48515 8.82155C5.33056 8.97614 5.24201 9.1847 5.23815 9.40329C5.2343 9.62188 5.31544 9.83343 5.46448 9.99338L8.44123 12.9712C8.52142 13.0513 8.61691 13.1144 8.72201 13.1567C8.8271 13.1991 8.93965 13.2198 9.05294 13.2177C9.16623 13.2156 9.27793 13.1907 9.38138 13.1445C9.48484 13.0983 9.57793 13.0317 9.6551 12.9488L14.1461 7.335C14.2992 7.17581 14.3838 6.96293 14.3817 6.74208C14.3796 6.52122 14.291 6.30999 14.1349 6.15375H14.1337Z",
    fill: "#027A48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreencheck);
export default __webpack_public_path__ + "static/media/greencheck.50dd1f46566d59a68a95ccb729934356.svg";
export { ForwardRef as ReactComponent };